import { Badge, Box, Card, Flex, Group, Stack, Text } from '@mantine/core';
import { IconUser } from '@tabler/icons-react';
import { useMemo } from 'react';

import { InstagramComment } from '../../../../types/instagram-comments';

type Props = {
  comment: InstagramComment;
};

export const CommentCard = ({ comment }: Props) => {
  const isDeleted = comment.isDeleted || false;

  const formattedDate = useMemo(() => {
    const date = new Date(comment.createdAt);
    return new Intl.DateTimeFormat('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }).format(date);
  }, [comment.createdAt]);

  return (
    <Card
      shadow="sm"
      padding="md"
      radius="md"
      withBorder
      style={{
        opacity: isDeleted ? 0.5 : 1,
        pointerEvents: isDeleted ? 'none' : 'auto',
        cursor: isDeleted ? 'not-allowed' : 'default',
      }}
    >
      <Stack gap="sm">
        <Flex justify="space-between" align="center">
          <Group gap="xs">
            <IconUser size={20} style={{ opacity: isDeleted ? 0.5 : 1 }} />
            <div>
              <Text fw={600} size="sm" c={isDeleted ? 'dimmed' : undefined}>
                {comment.author.username || comment.author.id}
              </Text>
              {comment.author.username && (
                <Text size="xs" c="dimmed">
                  @{comment.author.username}
                </Text>
              )}
            </div>
          </Group>
          <Group gap="xs">
            {isDeleted && (
              <Badge size="xs" color="gray" variant="light">
                Удалён
              </Badge>
            )}
            <Text size="xs" c="dimmed">
              {formattedDate}
            </Text>
          </Group>
        </Flex>

        <Box>
          <Text size="xs" c="dimmed" mb={4}>
            Comment:
          </Text>
          <Text
            size="sm"
            c={isDeleted ? 'dimmed' : undefined}
            td={isDeleted ? 'line-through' : undefined}
          >
            {comment.text}
          </Text>
        </Box>

        {comment.commentResponse && !isDeleted && (
          <Box>
            <Text size="xs" c="dimmed" mb={4}>
              Public answer:
            </Text>
            <Text size="sm" c="blue">
              {comment.commentResponse}
            </Text>
          </Box>
        )}

        {comment.directResponse && !isDeleted && (
          <Box>
            <Text size="xs" c="dimmed" mb={4}>
              Answer in Direct:
            </Text>
            <Text size="sm" c="green">
              {comment.directResponse}
            </Text>
          </Box>
        )}

        {comment.pilot?.name && (
          <Group gap="xs">
            <Text size="xs" c="dimmed">
              Pilot:
            </Text>
            <Badge size="sm" variant="light">
              {comment.pilot.name}
            </Badge>
          </Group>
        )}
      </Stack>
    </Card>
  );
};
